var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vk-card-title',[_c('div',{staticClass:"header-control"},[_c('div',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"header-controls"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }